import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Master switch for feed separator separators. Off by default so every existing
// feed renders byte-identically until an author opts in.
export default class FeedSeparatorsEnabled extends BaseOption {
  static userInterfaceComponent = {
    label: "Conditional Separators",
    component: inspectorTools.RADIO_BAR,
    optionDataType: BaseOption.DataType.Boolean,
    descriptionMessage:
      "Split this feed into groups with a separator above each one.",
    props: {
      options: [
        { label: "On", value: true, tooltip: "" },
        { label: "Off", value: false, tooltip: "" },
      ],
    },
  };

  static defaultValue = false;
}
